import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransportOrderIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { TransportOrderOverviewData } from '../../models/transport-order-overview.model';
import { TransportOrderOverviewState } from './transport-order-overview.state';
import { TransportOrderOverviewLoad, TransportOrderOverviewSetInitialState } from './transport-order-overview.actions';

@Injectable({ providedIn: 'root' })
export class TransportOrderOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(TransportOrderOverviewState.getLoaded);
  overview$: Observable<TransportOrderOverviewData> = this.store.select(TransportOrderOverviewState.getOverview);

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new TransportOrderOverviewLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportOrderOverviewSetInitialState());
  }
}
